import { comparePdfLabels, pdfHeaderText } from "../pdfTagName";
export type ReportTable = { layoutKey?: string; parentGroupTitle?: string; groupTitle?: string; title?: string; columns: string[]; rows: string[][];
  headerSpans?: { column: number; count: number }[];
  minimumRowHeight?: number;
  bulletNoteCells?: { row: number; column: number }[];
  rowGroupStarts?: number[]; groupedColumns?: number[]; groupBorderColor?: string;
  bridgeColumns?: { column: number;
    rows: ({ kind: "neutral" | "live"; tag: string; start: boolean; incoming: boolean; outgoing: boolean; dot: boolean } | undefined)[] }[] };
export type ReportDetail = { label: string; value: string };
export type ReportSection = { title: string; frontImage?: string; hierarchy?: readonly [string, string]; detailsTitle?: string; details?: ReportDetail[]; tables: ReportTable[]; notes?: string[] };
export type TechnicalReport = { sections: ReportSection[]; landscape?: boolean; keepSectionsTogether?: boolean };

/** Formats model labels without leaking undefined values into documents. */
export function label(object?: { fullTag?: string; name?: string; nameOfDefaultName?: string } | null): string {
  return object ? pdfHeaderText(object) : "";
}

/** Sorts live objects by the visible tag or name without changing the model collection. */
export function sorted<T extends { fullTag?: string; tag?: string; isDeleted?: boolean }>(items: readonly T[]): T[] {
  return items.filter(item => !item.isDeleted).sort((a, b) =>
    comparePdfLabels(a, b));
}

/** Normalizes numeric product attributes without propagating NaN into totals. */
export function number(value: unknown): number {
  const parsed = Number.parseFloat(String(value ?? "").replace(",", "."));
  return Number.isFinite(parsed) ? parsed : 0;
}
